import React from 'react';
import BoundInput from './BoundInput.js';
import BoundSelect from './BoundSelect.js';
import BoundMonacoEditor from './BoundMonacoEditor.js';

const BoundFormGroup = ({ formId, fields, onChange }) => {
  const fieldGroups = (fields || [])
    .filter((m) => typeof m === 'object' && m !== null)
    .map((m) =>
      m
        .filter((n) => typeof n === 'object' && n !== null && n.hidden !== true)
        .map((n) => ({ ...n, type: n.type || (n.options ? 'select' : 'input') }))
        .map((n) => ({
          ...n,
          Component: {
            password: BoundInput,
            number: BoundInput,
            textarea: BoundInput,
            input: BoundInput,
            select: BoundSelect,
            monaco: BoundMonacoEditor,
          }[n.type],
        }))
    )
    .filter((n) => n.length > 0);

  const handleChange = (field) => (val) => {
    if (field.onChange) {
      field.onChange(val);
    }
    if (onChange) {
      onChange({ id: field.id, value: val });
    }
  };

  return (
    <>
      {fieldGroups.map((group, groupIdx) => (
        <div className={`col${group.length}`} key={groupIdx}>
          {group.map((field = {}, idx) => (
            <field.Component key={idx} formId={formId} id={field.id} placeholder={field.placeholder} options={field.options} onChange={handleChange(field)} onBlur={field.onBlur} defaultValue={field.defaultValue} nullable={field.nullable} nullableLabel={field.nullableLabel} language={field.language} disabled={field.disabled} autoFocus={field.autoFocus} autoComplete={field.autoComplete} required={field.required} className={field.className} type={field.type} freeform={field.freeform} format={field.format} disablePasswordValidation={field.disablePasswordValidation} />
          ))}
        </div>
      ))}
    </>
  );
};

export default BoundFormGroup;
